import { jsonOrTextFromResponse, ocultarSpinner, mostrarSpinner, renderAlertas, eliminarErroresSpan} from "./utils.js";
import { mostrarMensajeError, mostrarMensajeExito } from "./swal.js";
import {CAPTCHA_PUBLIC_KEY} from "./app.js";

const reclamaciones = document.querySelector('#reclamaciones');

if(reclamaciones){
    document.addEventListener('DOMContentLoaded', ()=>{
        const formReclamaciones = document.querySelector('#formReclamaciones');
        const btnEnviar = document.querySelector('#enviar');
        if(formReclamaciones && btnEnviar){
            let exito = false;

            const departamentos = document.querySelector('#departamento');
            const provincias = document.querySelector('#provincia');
            const distritos = document.querySelector('#distrito');

            
            formReclamaciones.addEventListener('submit', async (e)=>{
                e.preventDefault();
                const email = document.querySelector('#email');
                const emailValue = email.value;                

                eliminarErroresSpan();
                
                mostrarSpinner();

                grecaptcha.ready(async function() {
                    try {
                        const token = await grecaptcha.execute(CAPTCHA_PUBLIC_KEY, {action: 'submit_form'});
                        document.getElementById('recaptchaResponse').value = token;
        
                        const departamentoSeleccionado = departamentos.options[departamentos.selectedIndex].textContent;
                        const provinciaSeleccionado = provincias.options[provincias.selectedIndex].textContent;
                        const distritoSeleccionado = distritos.options[distritos.selectedIndex].textContent;
        
                        const formData = new FormData(formReclamaciones);
                        formData.set('departamento', departamentoSeleccionado);
                        formData.set('provincia', provinciaSeleccionado);
                        formData.set('distrito', distritoSeleccionado);

                        const response = await fetch('/libro-de-reclamaciones', {
                            method: 'POST',
                            body: formData
                        })
    
                        const contentResponse = await jsonOrTextFromResponse(response);

                        if(typeof contentResponse === 'object'){
                            if('error' in contentResponse){
                                renderAlertas(contentResponse, {ubicacion: 'abajo'});
                                exito = false;
                                
                                if(contentResponse.error === 'No se pudo enviar el reclamo'){
                                    formReclamaciones.reset();
                                    throw new Error(contentResponse.error);
                                }                                
                            }else{        
                                formReclamaciones.reset();
                                exito = true;
                            }
                        }
    
    
                    } catch (error) {
                        ocultarSpinner();
                        console.log('Error al enviar reclamo: ', error);
                        await mostrarMensajeError({title: 'Error de envío', text: 'No se pudo procesar tu solicitud. Inténtalo de nuevo.', timer: null});
                        exito = false;
        
                    }finally {
                        ocultarSpinner();
                        if(exito){
                           await mostrarMensajeExito({title: 'Reclamo enviado con éxito', text: `Hemos enviado una copia a tu email ${emailValue}`, timer: 4000})
                        }
                    }
                }) // fin del recaptcha
            })
        }
    })
}